import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiRelatedSectionDTO,
  RelatedSectionDTO,
} from "@lib/strapi/dtos/components/sections/relatedSection.dto";

export class RelatedSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiRelatedSectionDTO,
  ): Promise<RelatedSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new RelatedSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.direction = strapiData.direction;
    return dto;
  }
}
